/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import {
  colors,
  DoubleChevronLeftIcon,
  DoubleChevronRightIcon
} from "@dotnet/telematics-design-system";

import Tooltip from "../../../../Tooltip/Tooltip";
import { useStyles } from "../../../styles";

interface IToggledrawerButtonProps {
  isdrawerOpen: boolean;
  onOpendrawer: () => void;
  onDrawerClose: () => void;
}

const ToggleDrawerButton = ({
  isdrawerOpen,
  onOpendrawer,
  onDrawerClose
}: IToggledrawerButtonProps) => {
  const { t } = useTranslation();

  const { toggleDrawerIcon, navigationItem } = useStyles();

  const renderIconWithTooltip = (children: any) => {
    if (!isdrawerOpen) {
      return (
        <Tooltip
          title={t("Navigation##expand menu")}
          placement="right"
          size="medium"
        >
          <div css={css(toggleDrawerIcon)} data-testid="open-navigation-button">
            {children}
          </div>
        </Tooltip>
      );
    } else {
      return children;
    }
  };

  return (
    <div
      data-testid="toggle-navigation-button"
      onClick={isdrawerOpen ? onDrawerClose : onOpendrawer}
      css={css([
        {
          cursor: "pointer",
          "& > svg": {
            color: colors.gray700
          },

          "&:hover": {
            backgroundColor: colors.gray100
          }
        },
        navigationItem
      ])}
    >
      {isdrawerOpen ? (
        <DoubleChevronLeftIcon />
      ) : (
        renderIconWithTooltip(<DoubleChevronRightIcon />)
      )}
      <Typography
        variant="body2Medium"
        css={css({
          marginLeft: "8px",
          whiteSpace: "nowrap"
        })}
      >
        {t("Navigation##collapse menu")}
      </Typography>
    </div>
  );
};

export default ToggleDrawerButton;
